import React from 'react'
import styles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import Button from '../common/ui-components/input/Button';
import UIModal from '../common/ui-components/surface/UIModal';
import {changeProgress} from '../../redux/actions/selfserveActions';
import { useDispatch } from 'react-redux';
import { Hidden } from '@mui/material';
import { cleverTapTrigger } from '../../tracking/segment';

interface MainProps{
    closeModal: any,
    planName: string,
    copayAmount: string,
    is_open: boolean,
    isMultiCover:boolean,
    copaymentscreenDamageAmount: string,
    copaymentReplacementAmount: string,
    copaymentAccessoriesAmount: string,
    hasProblemBasedCopay: boolean
    copayDescription: string
    copayDisclaimerNote: string
    tokenizedOsid:string
}
const CopayAlert = (props: MainProps) => {

    const dispatch:any = useDispatch();
    const close = () => {
            props.closeModal(false)
    }
    const proceed = () => {
        console.log('proceed to issue selection page')
        props.closeModal(false)
        dispatch(changeProgress(5));
    }
    return (
        <UIModal isOpen={props.is_open} onClick={close} larger={false} boxClass={styles.apply_box}>
            <div className={styles.selfserve_alert}>
                <h5 className={styles.selfserve_alert__title}>Copay Amount Applicable</h5>
                <div className={styles.selfserve_alert__text}>
                {props.copayDescription && props.copayAmount && (
                <p dangerouslySetInnerHTML={{ __html: `${props.copayDescription}` }} />
                )}
                {props.copayDisclaimerNote && (
                    <p dangerouslySetInnerHTML={{ __html: `Note: ${props.copayDisclaimerNote}` }} />
                )}
                </div>
                <p>For more details, refer{' '}
                  <a
                    href={`/terms-of-service?osid=${props.tokenizedOsid}`}
                    target="_blank"
                    rel="noopener noreferrer" 
                    onClick={(e) => {
                        cleverTapTrigger("Terms of Service Clicked",{"page name":"Copay Modal"})
                      e.stopPropagation();
                    }}
                  >
                    <i> Terms of Service</i>
                  </a>
                </p>
                <Hidden smUp>
                    <div className={commonStyles.single_button} style={{'marginTop' : "0"}}>

                        <Button
                            onClick={proceed}
                            text="Proceed"
                            className={commonStyles.single_btn}
                            style={{'fontSize': '14px'}}
                        />
                    </div>
                </Hidden>

                <Hidden smDown>
                    <div className={commonStyles.button_actions_sticky} data-varient='non-sticky' style={{'marginBottom': '40px', 'marginTop' : "20px"}}>

                        <Button
                            onClick={proceed}
                            text="Proceed"
                            className={commonStyles.cart_btn}
                            style={{'fontSize': '14px'}}
                        />
                    </div>
                </Hidden>
            </div>

        </UIModal>
    );
}

export default CopayAlert